import { useQuery } from "@tanstack/react-query";
import { ClaimControllerApi } from "../../../services";
import { getConfigObject, getXtenantId } from "../../../utils/utils";

/**
 * Denied-claim "View Denial" fetch.
 * Calls the lightweight claim-by-id endpoint
 * (`/api/master/claim/{claimUuid}/liteWeight`), whose payload carries the
 * denial JSON. Fetched lazily, only when a denial view is requested.
 */
export const useGetClaimDenial = (claimUuid: string, enabled = true) =>
  useQuery({
    enabled: !!claimUuid && enabled,
    queryKey: ["get-claim-denial", claimUuid],
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new ClaimControllerApi(getConfigObject())
        .getClaimByIdLite(claimUuid, getXtenantId())
        .then((it) => it?.data?.data),
  });
